import { Injectable } from '@angular/core';

import { FixtureFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Observable, map, of } from 'rxjs';

import { ShowcaseApi } from '../cds/showcase-api.service';
import { ShowcaseRequestBuilderService } from './showcase-request-builder.service';
import { ShowcaseEventModel } from './showcase.model';

@Injectable()
export class EventLoadService {
    constructor(
        private requestBuilderService: ShowcaseRequestBuilderService,
        private showcaseApi: ShowcaseApi,
        private fixtureFactory: FixtureFactory,
    ) {}

    getFullFixture(
        activeTabModel: ShowcaseEventModel,
        groupIds: string[],
    ): Observable<{
        event: EventModel;
        isUpdatedEvent: boolean;
    }> {
        const event = activeTabModel.event;
        if (!event.optionGroups.length && !event.scoreboard?.isFinished) {
            return this.getShowcaseData(event.id, groupIds).pipe(
                map((eventData) => ({
                    event: eventData.event || event,
                    isUpdatedEvent: eventData.isUpdatedEvent,
                })),
            );
        }

        return of({ event, isUpdatedEvent: false });
    }

    private getShowcaseData(
        fixtureId: string,
        groupIds: string[],
    ): Observable<{
        event: EventModel | undefined;
        isUpdatedEvent: boolean;
    }> {
        const request = this.requestBuilderService.buildRequestForOptionGroup(fixtureId, groupIds);

        return this.showcaseApi.getShowcaseData(request).pipe(
            map((response) => {
                const fixture = response?.fixtures[0]?.fixture;
                let event: EventModel | undefined;
                if (fixture && (fixture.optionMarkets || fixture.games)) {
                    event = this.fixtureFactory.create(fixture);
                }

                return { event, isUpdatedEvent: true };
            }),
        );
    }
}
